/** Public route templates used by the animal-browser feature. */
export const animalBrowserRoutePaths = {
    stablesBrowser: '/animal-browser/stables',
    cowBrowser: '/animal-browser/cow-browser/:id',
    calfBrowser: '/animal-browser/calf-browser/:id',
    comprehensiveBreedingFemaleBrowser: '/komplexni-seznam-plemenic',
    comprehensiveCalfBrowser: '/komplexni-seznam-telat',
};
